/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkPackagePriorityDto } from '../../models/work-package-priority-dto';

export interface GetWorkPackagePriority$Params {
  id: string;
}

export function getWorkPackagePriority(http: HttpClient, rootUrl: string, params: GetWorkPackagePriority$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackagePriorityDto>> {
  const rb = new RequestBuilder(rootUrl, getWorkPackagePriority.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkPackagePriorityDto>;
    })
  );
}

getWorkPackagePriority.PATH = '/v0/workPackagePriorities/{id}';
